<template>
  <div>
    <breadcrumb :breadcrumb="breadcrumb" />
    <div class="search-line">
      <div class="btn-box">
        <button-add :pathName="addDataParkHonor" v-if="permissionCodes.indexOf('034009001') !== -1"/>
        <button-cancel value="查询所有人员排班记录" @cancel="getAttendanceScheduleAll"/>
        <!--<button-delete @deleteSelection="deleteSelection" />-->
      </div>
      <input-search placeholder="班组名称" @search="searchKey" />
    </div>
    <table-main :selection="false" :tableHead="tableHead" :tableData="tableData" @schedulingRow="toSchedulingPage" @deleteLine="deleteLine" :deleteTipInfo="'是否确认删除该排班？'" @goToModifyPage="goToModifyPage" @changeSelection="changeSelection" :total="total" :pageNum="requestData.pageNum" :pageSize="requestData.pageSize" :operationArr="operationArr" @changePagination="changePagination" />
  </div>
</template>

<script>
  import Breadcrumb from '../../../components/Breadcrumb/Breadcrumb'
  import ButtonAdd from '../../../components/Button/ButtonAdd'
  import ButtonDelete from '../../../components/Button/ButtonDelete'
  import ButtonExport from '../../../components/common/buttons/button-export'
  import ButtonUpload from '../../../components/common/buttons/button-upload'
  import InputSearch from '../../../components/Input/InputSearch'
  import InputSelect from '../../../components/Input/InputSelect'
  import TableMain from '../../../components/Table/TableMain'
  import {api} from '../../api/AttendancePoint'
  import {errorHandler} from '../../../utils/errorHandler'
  import {nAlert, nError, nSuccess} from '../../../utils/notice'
  import {bus} from '../../../utils/bus'
  import ButtonCancel from "../../../components/Button/ButtonCancel";

  export default {
    components: {
      ButtonCancel,
      TableMain,
      InputSelect,
      InputSearch,
      ButtonUpload,
      ButtonExport,
      ButtonDelete,
      ButtonAdd,
      Breadcrumb
    },
    name: 'attendance-scheduling-manage',
    data () {
      return {
        permissionCodes: '',
        breadcrumb: [{
          value: '智慧考勤',
          name: 'attendance-department-manage'
        }, {
          value: '排班管理'
        }],
        addDataParkHonor: 'attendance-scheduling-add',
        operationArr: ['scheduling', 'delete'],

        tableHead: [{
          prop: 'groupName',
          label: '班组名称'
        }, {
          prop: 'classesArrName',
          label: '班次'
        }],
        tableData: [],
        total: 0,
        selectionArr: [],
        requestData: {
          searchKey: '',
          pageSize: 10,
          pageNum: 1,
        },

        allPersonVisible: false,
        allPersonList: []
      }
    },
    created () {
      this.permissionCodes = bus.global.permissionCodes
      this.getPage()
    },
    activated() {
      this.getPage()
    },
    methods: {
      getPage () {
        this.$axios.post(api.getGroupClassesRelationPage, this.requestData)
          .then(res => {
            if (res.data.retCode === 1) {
              let data = res.data.data.list
              data.map(v => {
                v.code = v.groupCode
                let classesList = v.classesList || [], classesArrName = []
                classesList.map(classItem => {
                  classesArrName.push(classItem.classesName)
                })
                v.classesArrName = classesArrName.join('，')
              })
              this.total = res.data.data.total
              this.tableData = data
            }
          })
          .catch(errorHandler('获取数据失败'))
      },
      search (v) {
        this.requestData[v.key] = v.value
        this.getPage()
      },
      searchKey (v) {
        this.requestData.pageNum = 1
        this.requestData.searchKey = v
        this.getPage()
      },
      changePagination (data) {
        this.requestData.pageNum = data[0]
        this.requestData.pageSize = data[1]
        this.getPage()
      },
      changeSelection (codeArr) {
        this.selectionArr = codeArr
      },
      goToModifyPage (code) {
        this.$router.push({
          path: '/attendance_team_modify/' + code
        })
      },

      toSchedulingPage (data) {
        this.$router.push({
          path: '/attendance_scheduling_rank/' + data.code
        })
      },

      deleteLine (code) {
        this.$axios.post(api.deleteGroupClassesRelationByCodes, code)
          .then(res => {
            if (res.data.retCode === 1) {
              nSuccess('删除成功')
              this.selectionArr = []
              this.getPage()
            }
          })
          .catch(errorHandler('删除失败'))
      },

      getAttendanceScheduleAll () {
        this.$router.push({
          name: 'attendance-scheduling-rank-detail'
        })
      }
    },
    watch: {
      centEndTime(val) {
        this.getPage()
      }
    }
  }
</script>

<style scoped>
  .form-line {
    width: 420px;
    margin: 20px auto;
    display: flex;
    justify-content: flex-start;
  }
  .form-line>div {
    margin-right: 20px;
  }
  .line-text{
    color: #48576a;
    font-size: 14px;
    margin-right: 10px;
  }
  .textBox {
    display: inline-block;
    width: 122px;
    line-height: 32px;
    text-align: right;
  }
  .red {
    color: red;
  }
  .search-line {
    display: flex;
    justify-content: space-between;
    margin: 20px 0;
  }
  .btn-box {
    display: flex;
    justify-content: flex-start;
  }
</style>



// WEBPACK FOOTER //
// src/view/WorkAttendance/AttendanceScheduling/AttendanceSchedulingManage.vue